<template>
  <div class="ly_modal_container" :style="{width: '840px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">일반소식 전송이력</h1>
    </div>
    <div class="ly_modal_content" style="min-height:469px">
      <template v-if="detailData" class="table_wrapper">
        <div class="section_textarea">
          <span class="ico"></span>최초 전송시간 :
          <span class="highlight">{{firstSendDate}}</span>
        </div>
        <ScrollTable
          :sourceList="detailData"
          ref="table"
          emptyText="전송이력은 2020년 8월 12일 이후에 등록된 소식에서 볼 수 있습니다."
        >
          <template #header>
            <caption>
              <span class="blind">전송건수</span>
            </caption>
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col width="30%" />
            </colgroup>
            <thead class="table_list_head">
              <tr>
                <th>번호</th>
                <th>전송건수</th>
                <th>알림 성공수</th>
                <th>전송종류</th>
                <th>전송 시간</th>
              </tr>
            </thead>
          </template>
          <template #row="{rowData}">
            <tr>
              <td>{{rowData._index + 1}}</td>
              <td>{{rowData.sendCount}}</td>
              <td>{{rowData.successCount}}</td>
              <td>{{getGeneralSendTypeText(rowData.sendType)}}</td>
              <td>{{$utils.timeText(rowData.firstSendDate)}}</td>
            </tr>
          </template>
        </ScrollTable>
      </template>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import newsMixin from "$views/News/_mixin";
import popupMixin from "$mixins/popup";

export default {
  mixins: [newsMixin, popupMixin],
  props: {
    newsId: [String, Number]
  },
  data() {
    return {
      detailData: null
    };
  },
  computed: {
    firstSendDate() {
      if (_.isEmpty(this.detailData)) return "-";
      return this.$utils.timeText(
        this.detailData[this.detailData.length - 1].firstSendDate
      );
    }
  },
  mounted() {
    this.$axios
      .get(`/admin/happy/news/${this.newsId}/logs`)
      .then(({ data }) => (this.detailData = data.data));
  }
};
</script>
